var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-list',{attrs:{"endpoint":"tipo-documento-anexo","rota-base":"/admin/tipo-documento-anexo","titulo":"TIPOS DE DOCUMENTOS ANEXO","titulo-singular":"Tipo de Documento Anexo","colunas-extras":[
        { campo: "descricao", label: "Descrição", tipo: "string" }
    ]}})
}
var staticRenderFns = []

export { render, staticRenderFns }